import React from "react";
import { View, Text, Button, TextInput } from "ui";
import { styled } from "styles";
import { Header, Footer, InstallApp } from "components";
import { authMutations } from "api";
import { store } from "store";
import { Actions } from "../store/reducer";
import { connect } from "react-redux";
import { notify } from "../shared/services/notify";

export default class ForgotPassword extends React.Component {
  public state = {
    username: "",
  };

  public render = () => {
    const { username } = this.state;
    return (
      <authMutations.ForgotPassword>
        {forgotPassword => (
          <form
            onSubmit={async e => {
              e.preventDefault();
              try {
                await forgotPassword({
                  variables: {
                    identifier: username
                  }
                });
                notify("Vezi codul din mesaj!");
              } catch (ex) {}
            }}
          >
            <View
              pl={5}
              pr={5}
              mt={5}
              mb={3}
              flexDirection="column"
              alignItems="center"
            >
              <TextInput
                alignSelf="stretch"
                placeholder="Telefon/ e-mail"
                value={username}
                onChange={e => this.setState({ username: e.target.value })}
              />

              <Button
                p={2}
                mt={4}
                alignSelf="stretch"
                as="button"
                type="submit"
              >
                <Text fontSize={4} fontWeight="bold" color="white">
                  Reseteaza parola
                </Text>
              </Button>
            </View>
          </form>
        )}
      </authMutations.ForgotPassword>
    );
  }
}

const Forgot = styled(Text)`
  text-decoration: underline;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword.tsx